var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"model",style:({width:_vm.width,padding:_vm.padding})},[_c('div',{staticClass:"head"},[_c('div',[_c('h1',[_vm._v(_vm._s(_vm.title))])]),_c('div',[_c('h3',[_vm._v(_vm._s(_vm.tag))])])]),_c('div',{staticClass:"modelContent"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }